import styled from 'styled-components';
import Footer from '@/components/common/Footer';
import WarningExpired from '@/components/common/WarningExpired';
import useGetGlobalStatus from '@/hooks/useGetGlobalStatus';
import UpdateBanner from '@/components/common/UpdateBanner';
import GlobalPaymentList from '@/components/globalPayment/GlobalPaymentList';
import { useAppSelector } from '@/hooks/useReduxHooks';
import { useEffect, useState } from 'react';
import PaymentCreateModal from '@/components/globalPayment/PaymentCreate.modal';
import PaymentWaitModal from '@/components/globalPayment/PaymentWait.modal';
import PaymentCompleteModal from '@/components/globalPayment/PaymentComplete.modal';

function GlobalPayment() {
  const { isExpiryWarning, globalStatus } = useGetGlobalStatus();
  const { modal, loading } = useAppSelector((state) => state);
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    setIsActive(modal.isActive);
  }, [modal]);

  return (
    <Wrapper>
      <UpdateBanner />
      {isExpiryWarning && (
        <WarningExpired expiryDate={globalStatus?.promotionExpiryDate} />
      )}
      <Container>
        <GlobalPaymentList />
      </Container>
      <Footer />
      {isActive && modal?.type === 'PAYMENT_CREATE' && modal?.isActive && (
        <PaymentCreateModal {...modal?.data} />
      )}
      {isActive && modal?.type === 'PAYMENT_WAIT' && modal?.isActive && (
        <PaymentWaitModal {...modal?.data} />
      )}
      {isActive && modal?.type === 'PAYMENT_COMPLETE' && modal?.isActive && (
        <PaymentCompleteModal {...modal?.data} />
      )}
    </Wrapper>
  );
}

export default GlobalPayment;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 1080px;
  height: 100vh;
  flex: 1;
  overflow-y: scroll;
  background-color: ${(props) => props.theme.blueColors.scale3};
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 22px 40px 85px 40px;
`;
